import React from 'react';
import PriceLine from "./PriceLine"

class PriceLines extends React.Component {
  
  twoColumnsLines() {
    const { 
      linePadding, 
      labelName, valueName,
      contentLeft, contentRight
    } = this.props;

    const lines = [];

    for(let index = 0; index < Math.max(contentLeft.length, contentRight.length); index++) 
    {
      lines.push(
        <div key={index} style={{display: 'flex'}}>
          { index < contentLeft.length &&
            <div style={{width: '50%'}}>
              <PriceLine linePadding={linePadding}
                left={contentLeft[index][labelName]}
                right={contentLeft[index][valueName]} 
                backgroundColor={index % 2 == 0 ? 'var(--white-color)' : '#E6F2EA'}
              />
            </div>
          }
          { index < contentRight.length &&
            <div style={{width: '50%'}}>
              <PriceLine linePadding={linePadding}
                left={contentRight[index][labelName]}
                right={contentRight[index][valueName]} 
                backgroundColor={index % 2 == 0 ? 'var(--white-color)' : '#E6F2EA'}
              />
            </div>
          }
        </div>
      );
    }

    return lines;
  }
  
  render() {
    const { 
      content, linePadding, 
      labelName, valueName,
      contentLeft, contentRight
    } = this.props;

    return (
      <>
        { content.length > 0 &&
          content.map((line, index) => {
            return (
              <PriceLine key={index} 
                linePadding={linePadding}
                left={line[labelName]}
                right={line[valueName]} 
                backgroundColor={index % 2 == 0 ? 'var(--white-color)' : '#E6F2EA'}
              />
            );
          })
        }
        { 
          contentLeft.length > 0 && 
          contentRight.length > 0 && 
          this.twoColumnsLines() 
        }
      </>
    );
  }
};

PriceLines.defaultProps = {
  labelName: 'label', 
  valueName: 'value',
  linePadding:'normal',
  content: [],
  contentLeft: [],
  contentRight: [],
};

export default PriceLines;